module.exports = __webpack_public_path__ + "img/majlis.9a26ff22.jpg";